import { graphql } from '~/graphql/generated/gql';

export const videoDataFragment = graphql(`
  fragment VideoDataFields on VideoData {
    videoUrl
    description
    provider
    speakers {
      name
      organisation
      bio
      imageId
      imageUrl
      image {
        ...PublicFileFields
      }
    }
  }
`);

export const fetchVideoAssets = graphql(`
  query fetchVideoAssets($first: Int, $page: Int, $filters: AdminLearningAssetFilters, $orderBy: [AdminLearningAssetOrder!]) {
    learningAssetsList(first: $first, page: $page, filters: $filters, orderBy: $orderBy) {
      data {
        id
        name
        slug
        publishedAt
        publishedContentId
        draftContentId
        partner {
          id
          name
        }
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const adminVideoLearningAssetFragment = graphql(`
  fragment AdminVideoLearningAssetFields on AdminLearningAsset {
    id
    name
    slug
    publishedAt
    publishedContentId
    draftContentId
    coverImage {
      ...AdminContentFileFields
    }
    partnerId
    partner {
      id
      name
    }
    meta {
      title
      description
    }
    considerationAreas {
      id
      label
      slug
    }
    publishedContent {
      id
      videoData {
        ...VideoDataFields
      }
    }
    draftContent {
      id
      videoData {
        ...VideoDataFields
      }
    }
  }
`);

export const fetchAdminVideoLearningAsset = graphql(`
  query fetchAdminVideoLearningAsset($filters: AdminLearningAssetFilters) {
    learningAssetsList(filters: $filters) {
      data {
        ...AdminVideoLearningAssetFields
      }
    }
  }
`);

export const upsertVideoMutation = graphql(`
  mutation upsertVideo($input: UpsertLearningAssetInput!) {
    upsertLearningAsset(input: $input) {
      learningAsset {
        ...AdminVideoLearningAssetFields
      }
    }
  }
`);

export const publishVideoMutation = graphql(`
  mutation publishVideo($input: PublishLearningAssetInput!) {
    publishLearningAsset(input: $input) {
      success
      learningAsset {
        id
        publishedAt
        publishedContentId
        draftContentId
      }
    }
  }
`);

export const unpublishVideoMutation = graphql(`
  mutation unpublishVideo($input: UnpublishLearningAssetInput!) {
    unpublishLearningAsset(input: $input) {
      success
      learningAsset {
        id
        publishedAt
        publishedContentId
        draftContentId
      }
    }
  }
`);

export const videoLearningAssetFragment = graphql(`
  fragment VideoLearningAssetFields on LearningAsset {
    id
    name
    slug
    publishedAt
    coverImage {
      ...PublicFileFields
    }
    partner {
      id
      name
      iconFile {
        publicUrl
      }
    }
    meta {
      title
      description
    }
    publishedContent {
      id
      videoData {
        ...VideoDataFields
      }
    }
  }
`);

export const fetchVideoBySlug = graphql(`
  query fetchVideoBySlug($filters: LearningAssetFilters) {
    learningAssets(filters: $filters) {
      data {
        ...VideoLearningAssetFields
      }
    }
  }
`);

// One published video as a card (`toVideoCards`): a hub, the Learn rails, the Advice Videos grid.
export const videoCardFieldsFragment = graphql(`
  fragment VideoCardFields on LearningAsset {
    id
    name
    slug
    duration
    coverImage {
      publicUrl
    }
    partner {
      id
      name
      iconFile {
        publicUrl
      }
    }
  }
`);

export const fetchHubVideos = graphql(`
  query fetchHubVideos($considerationAreaSlug: String!, $first: Int!) {
    learningAssets(
      filters: { considerationAreaSlug: $considerationAreaSlug, types: [VIDEO], publishedOnly: true }
      orderBy: [{ column: PUBLISHED_AT, order: DESC }]
      first: $first
    ) {
      data {
        ...VideoCardFields
      }
    }
  }
`);

export const fetchLatestVideos = graphql(`
  query fetchLatestVideos($first: Int!) {
    learningAssets(
      filters: { types: [VIDEO], publishedOnly: true }
      orderBy: [{ column: PUBLISHED_AT, order: DESC }]
      first: $first
    ) {
      data {
        ...VideoCardFields
      }
    }
  }
`);

export const fetchVideosCatalogue = graphql(`
  query fetchVideosCatalogue($page: Int!, $first: Int!, $keyword: String) {
    learningAssets(
      filters: { types: [VIDEO], publishedOnly: true, keyword: $keyword }
      orderBy: [{ column: PUBLISHED_AT, order: DESC }]
      page: $page
      first: $first
    ) {
      data {
        ...VideoCardFields
      }
      paginatorInfo {
        currentPage
        hasMorePages
      }
    }
  }
`);
